import React from 'react';
import { Link } from 'react-router-dom';
import Hr from '../components/Hr';
import { withStyles } from 'material-ui/styles';
import connect from 'react-redux/es/connect/connect';
import withRouter from 'react-router-dom/es/withRouter';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import {
  SITE_OVERVIEW_HEADLINE,
  SITE_OVERVIEW_LOGGER_CHART,
  SITE_OVERVIEW_LOGGER_FLOW_CHART,
  SITE_OVERVIEW_NAV_CHARTS,
  SITE_OVERVIEW_NAV_FLOW_CHART
} from '../constants/actionMessages';

const styles = theme => ({
  links__group: {
    margin: theme.spacing.unit,
    textDecoration: 'none'
  },
  button: {
    margin: theme.spacing.unit
  },
  group: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '1rem',
    paddingBottom: '1rem',
    borderTop: '1px solid #ccc'
  },
  subgroup: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '1rem'
  }
});

const SiteOverview = ({ classes, match, loggers }) => (
  <div>
    <Typography type="title" gutterBottom>
      Site View
    </Typography>
    <Link className={classes.links__group} to={`${match.url}/sankey`}>
      <Button raised color="primary">
        {SITE_OVERVIEW_NAV_FLOW_CHART}
      </Button>
    </Link>

    <Link className={classes.links__group} to={`${match.url}/charts`}>
      <Button raised color="primary">
        {SITE_OVERVIEW_NAV_CHARTS}
      </Button>
    </Link>

    <Hr />

    <Typography type="title" gutterBottom>
      {SITE_OVERVIEW_HEADLINE}
    </Typography>

    {Object.keys(loggers)
      .map(loggerId => loggers[loggerId])
      .sort((a, b) => a.description > b.description)
      .map(logger => (
        <div key={logger.id}>
          <div className={classes.group}>
            <div>
              <h4>{logger.description}</h4>
              <ul>
                <li>{`Sensors: ${logger.sensors.length}`}</li>
                <li>{`Phases: ${logger.num_phases}`}</li>
                <li>{`Sample Frequency: ${logger.sample_frequency}`}</li>
                {logger.building ? (
                  <li>`Building: ${logger.building}`</li>
                ) : null}
              </ul>
            </div>
            <div>
              <Link
                className={classes.links__group}
                to={`${match.url}/logger/${logger.id}/sankey`}
              >
                <Button color="primary">
                  {SITE_OVERVIEW_LOGGER_FLOW_CHART}
                </Button>
              </Link>
              <Link
                className={classes.links__group}
                to={`${match.url}/logger/${logger.id}/charts`}
              >
                <Button color="primary">{SITE_OVERVIEW_LOGGER_CHART}</Button>
              </Link>
            </div>
          </div>
        </div>
      ))}
  </div>
);

const mapStateToProps = state => ({
  timezone: state.app.timezone,
  loggers: state.loggers
});

export default connect(mapStateToProps, {})(
  withStyles(styles, { name: 'SiteOverview' })(withRouter(SiteOverview))
);



// WEBPACK FOOTER //
// ./src/container/SiteOverview.js